import { CSSObject } from '@chakra-ui/react';

export const TabContainer: CSSObject = {
  border: '0',
};

export const TabWrapper: CSSObject = {
  gap: 1,
  bg: 'white',
  borderRadius: 'lg',
  boxShadow: '0 3px 8px rgba(0, 0, 0, .2)',
  p: '1.5',
};

export const TabOption = ({ isActive }: any): CSSObject => ({
  bg: isActive ? 'alpha.600' : 'transparent',
  borderRadius: 'md',
  boxShadow: 'none',
  color: isActive ? 'white' : 'gray.600',
  fontSize: '2xs',
  fontWeight: 'bold',
  h: 'auto',
  px: '2',
  py: '1',
  textShadow: isActive ? '0 2px 3px rgba(0, 0, 0, .2)' : 'none',

  _hover: {
    bg: isActive ? 'alpha.600' : 'transparent',
    color: isActive ? 'white' : 'gray.700',
  },

  _focus: {
    boxShadow: 'none',
  },

  _active: {
    bg: isActive ? 'alpha.600' : 'transparent',
    boxShadow: 'none',
    color: isActive ? 'white' : 'gray.700',
  },
});
